import { SimpleGrid, Box, Divider } from '@hover/blueprint';
import React, { useEffect } from 'react';
import { INVITED_BY_CONTRACTOR_LIST_DATA } from '../../../constants';
import HoverMaterials from '../../../assets/videos/hover_materials.mp4';
import { SwitcherDesktopItem } from '../../common';

interface Props {
  currentTab: number;
  setCurrentTab: React.Dispatch<React.SetStateAction<number>>;
  isIntersected: boolean;
}

const Desktop: React.FC<Props> = ({
  currentTab,
  setCurrentTab,
  isIntersected,
}) => {
  useEffect(() => {
    const currentVideo = document.getElementById(
      `invited-by-contractor-switcher-video-desktop`,
    ) as HTMLVideoElement;

    if (currentVideo && currentTab === 3) {
      currentVideo.load();
    }
  }, [currentTab]);
  return (
    <SimpleGrid
      w="100%"
      d={{ base: 'none', desktop: 'grid' }}
      columns={2}
      alignItems="center"
    >
      <Box maxW="480px" h="100%" w="100%" flexDir="column">
        <Divider
          borderColor="primary.200"
          borderWidth="1px"
          borderTopWidth={0}
          my={0}
          d={currentTab === 0 ? 'none' : 'block'}
        />
        {INVITED_BY_CONTRACTOR_LIST_DATA.map(listItem => (
          <SwitcherDesktopItem
            key={listItem.id}
            activeBackground="primary.100"
            body={listItem.body}
            borderColor="primary.200"
            currentTab={currentTab}
            isLast={listItem.id === INVITED_BY_CONTRACTOR_LIST_DATA.length - 1}
            itemIndex={listItem.id}
            setCurrentTab={setCurrentTab}
            title={listItem.title}
            titleColor="brandNavy.500"
            icon={listItem.icon}
            svgIcon={listItem.svgIcon}
          />
        ))}
      </Box>
      {INVITED_BY_CONTRACTOR_LIST_DATA.map(listItem => (
        <Box
          key={listItem.id}
          d={listItem.id === currentTab ? 'flex' : 'none'}
          alignItems="center"
          justifyContent="center"
          w="100%"
          maxH="355px"
        >
          {isIntersected && (
            <>
              {listItem.title !== 'TRANSPARENCY' ? (
                <Box maxH="355px" minH="355px">
                  {listItem.desktopImage}
                </Box>
              ) : (
                <Box border="solid" borderWidth="1px" borderColor="neutral.500">
                  <video
                    id="invited-by-contractor-switcher-video-desktop"
                    src={HoverMaterials}
                    muted
                    loop
                    autoPlay
                    playsInline
                  />
                </Box>
              )}
            </>
          )}
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default Desktop;
